module.exports = __webpack_public_path__ + "img/slide03_m.753db9b9.jpg";